import {api, handleApiError, ServiceResponse} from "../ApiClient";

export interface Caddie {
    id: string
    userId: string
    clubId: string
    prepaidBagBalance: number
    approved: boolean
}

export interface GetCaddiesResponse extends ServiceResponse {
    caddies?: Caddie[]
}

export const CaddieService = () => {

    const getForUser = async (userId: string): Promise<GetCaddiesResponse> => {
        return api.get<Caddie[]>(`/api/1/caddies?forUser=${userId}`)
            .then((resp) => {
                if (resp && resp.status === 200 && resp.data) {
                    return {
                        caddies: resp.data
                    }
                }

                return {
                    error: {
                        message: 'Could not get caddies.'
                    }
                }
            })
            .catch(handleApiError)
    }


    return {
        getCaddiesForUser: getForUser
    }
}
